import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Card highlighting a problem/pain-point. Used on VenuesPage.
 *
 * Props:
 *   icon        - React node (MUI icon)
 *   title       - string
 *   description - string
 */
const ProblemCard = ({ icon, title, description }) => (
  <Box
    sx={{
      p: 3,
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'secondary.light',
      height: '100%',
      transition: 'border-color 0.2s ease',
      '&:hover': {
        borderColor: 'primary.main',
      },
    }}
  >
    <Box sx={{ color: 'primary.main', mb: 2, '& svg': { fontSize: 28 } }}>
      {icon}
    </Box>
    <Typography
      variant="h6"
      sx={{
        fontFamily: '"Bebas Neue", sans-serif',
        letterSpacing: '0.05em',
        color: 'text.primary',
        mb: 1,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        color: 'text.secondary',
        fontSize: '0.9rem',
        lineHeight: 1.7,
      }}
    >
      {description}
    </Typography>
  </Box>
);

export default ProblemCard;
